// ============================================================
// cf-signalr.js ï¿½ SignalR Hub Connection for ArunaSalesPro.Web
// Loaded on every page via _Layout.cshtml (after cf-auth.js).
//
// Connects to /hubs/notification on the API server with JWT auth.
// Auto-reconnects with exponential backoff.
//
// Listens for server-pushed events and dispatches to CF modules:
//   - "user.context-changed"                    ? CF.auth.invalidateMe(true)
//   - "notification.inapp.received"             ? CF.notification.onReceived
//   - "notification.inapp.unread-count-changed" ? CF.notification.onUnreadCountChanged
//   - "notification.approval.received"          ? CF.notification.onApprovalReceived
//   - "notification.approval.pending-count-changed" ? CF.notification.onApprovalCountChanged
//   - "notification.approval.dismissed"         ? CF.notification.onApprovalDismissed
//
// Public API:
//   CF.signalR.start()      ï¿½ called automatically by cf-auth.js after loadMe()
//   CF.signalR.stop()       ï¿½ called on logout
//   CF.signalR.connection   ï¿½ raw HubConnection (for page scripts if needed)
// ============================================================

window.CF = window.CF || {};

CF.signalR = (function () {
    'use strict';

    var _connection = null;
    var _started    = false;

    var HUB_PATH = '/hubs/notification';

    function _hubUrl() {
        var base = (typeof API_BASE_URL !== 'undefined' && API_BASE_URL)
            ? API_BASE_URL
            : '';
        return base + HUB_PATH;
    }

    // ????????????????????????????????????????
    // PUBLIC: start()
    // Creates and starts the SignalR connection.
    // Safe to call multiple times ï¿½ skips if already connected.
    // ????????????????????????????????????????
    function start() {
        if (_started && _connection) return;
        if (typeof signalR === 'undefined') return;

        var token = CF.auth.getAccessToken();
        if (!token) return;

        _connection = new signalR.HubConnectionBuilder()
            .withUrl(_hubUrl(), {
                accessTokenFactory: function () {
                    return CF.auth.getAccessToken();
                }
            })
            .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
            .build();

        // ?? Event: user context changed ????????????
        _connection.on('user.context-changed', function () {
            CF.auth.invalidateMe(true);
        });

        // ?? Event: in-app notification received ????
        _connection.on('notification.inapp.received', function (payload) {
            if (typeof CF.notification !== 'undefined' && CF.notification.onReceived) {
                CF.notification.onReceived(payload);
            }
        });

        // ?? Event: in-app unread count changed ?????
        _connection.on('notification.inapp.unread-count-changed', function (payload) {
            if (typeof CF.notification !== 'undefined' && CF.notification.onUnreadCountChanged) {
                CF.notification.onUnreadCountChanged(payload);
            }
        });

        // ?? Event: approval received ???????????????
        _connection.on('notification.approval.received', function (payload) {
            if (typeof CF.notification !== 'undefined' && CF.notification.onApprovalReceived) {
                CF.notification.onApprovalReceived(payload);
            }
        });

        // ?? Event: approval pending count changed ??
        _connection.on('notification.approval.pending-count-changed', function (payload) {
            if (typeof CF.notification !== 'undefined' && CF.notification.onApprovalCountChanged) {
                CF.notification.onApprovalCountChanged(payload);
            }
        });

        // ?? Event: approval dismissed ??????????????
        _connection.on('notification.approval.dismissed', function (payload) {
            if (typeof CF.notification !== 'undefined' && CF.notification.onApprovalDismissed) {
                CF.notification.onApprovalDismissed(payload);
            }
        });

        // ── Event: monitoring visit changed (W1/W3) ──
        // Dispatch sebagai DOM event supaya page script cukup
        // addEventListener('cf:monitoring-changed', ...) tanpa
        // bergantung urutan start() vs page ready.
        _connection.on('monitoring.visit-changed', function (payload) {
            document.dispatchEvent(new CustomEvent('cf:monitoring-changed', { detail: payload || {} }));
        });

        // ?? Event: export progress ?????????????????
        _connection.on('export.progress', function (payload) {
            if (typeof CF.exports !== 'undefined' && CF.exports.onProgress) {
                CF.exports.onProgress(payload);
            }
        });

        // ?? Event: export completed ????????????????
        _connection.on('export.completed', function (payload) {
            if (typeof CF.exports !== 'undefined' && CF.exports.onCompleted) {
                CF.exports.onCompleted(payload);
            }
            if (typeof CF.toast !== 'undefined' && payload && payload.exportJobId) {
                var safeId   = String(payload.exportJobId).replace(/[^A-Za-z0-9-]/g, '');
                var rawName  = String(payload.fileName || 'export.xlsx');
                var safeName = rawName.replace(/[<>"'&\\]/g, '');
                var link =
                    '<a href="#" style="color:#fff;text-decoration:underline" ' +
                    'onclick="CF.exports.download(\'' + safeId + '\',\'' + safeName + '\');return false;">' +
                    'Download ' + safeName + '</a>';
                CF.toast.success(link, 'Export selesai');
            }
        });

        // ?? Event: export failed ???????????????????
        _connection.on('export.failed', function (payload) {
            if (typeof CF.exports !== 'undefined' && CF.exports.onFailed) {
                CF.exports.onFailed(payload);
            }
            if (typeof CF.toast !== 'undefined') {
                CF.toast.error((payload && payload.error) || 'Export failed.', 'Export gagal');
            }
        });

        // ?? Lifecycle: reconnected ?????????????????
        // After reconnect, notifications pushed during the disconnect
        // window were lost. Re-fetch notification state from API.
        _connection.onreconnected(function () {
            _started = true;
            if (typeof CF.notification !== 'undefined' && CF.notification.resync) {
                CF.notification.resync();
            }
        });

        // ?? Lifecycle: reconnecting ????????????????
        _connection.onreconnecting(function () {
            _started = false;
        });

        // ?? Lifecycle: closed ??????????????????????
        _connection.onclose(function () {
            _started = false;
        });

        // ?? Start ??????????????????????????????????
        _connection.start()
            .then(function () {
                _started = true;
            })
            .catch(function () {
                _started = false;
            });
    }

    // ????????????????????????????????????????
    // PUBLIC: stop()
    // Gracefully stops the connection. Called on logout.
    // ????????????????????????????????????????
    function stop() {
        if (_connection) {
            _connection.stop();
            _connection = null;
            _started = false;
        }
    }

    return {
        start:      start,
        stop:       stop,
        get connection() { return _connection; }
    };

})();
